import type { Action } from '@atlassian/react-sweet-state';
import { listJNAAppsEndpoint } from '../endpoints';
import type { JNAAppStatus } from '../types';

export type TransitioningStatusStoreContainerProps = {
	cloudId: string;
};

const getData =
	(): Action<JNAAppStatus, TransitioningStatusStoreContainerProps> =>
	({ setState, getState }, { cloudId }) => {
		const { loading } = getState();
		if (loading) {
			// We are already fetching and will receive results, no need to start another request
			return;
		}

		setState({
			loading: true,
		});

		return (
			listJNAAppsEndpoint(cloudId)
				// Drop any unnecessary fields
				.then(({ values }) => ({ values }))
				.then(setState)
				.catch((error) => {
					// TODO: we might display toast
					setState({ error });
					throw error;
				})
				.finally(() => {
					setState({ loading: false });
				})
		);
	};

const initialize = getData;

export const actions = { initialize };
